import Background from 'Components/Reusable/Background/Background';
import MembershipCards from 'Components/Membership/MembershipCards';
import OverlapCard from 'Components/Reusable/Cards/OverlapCard';
import basic from 'Assets/img/svg/membership/basicBG.svg';
import premium from 'Assets/img/svg/membership/premiumBG.svg';
import React, { Fragment, useEffect } from 'react';
import { useStyles } from './membership.style';
import { useDispatch, useSelector } from 'react-redux';
import { getMilestoneCategories } from 'ReduxStore/milestones/Action';
import { RootState } from 'ReduxStore';
import { useParams } from 'react-router-dom';
import { typesOfMembership } from 'Utils/information';
import { changeIdentities } from 'Helpers';
import { GetAllKids } from 'ReduxStore/children/Action';
import { BackButton } from 'Components/Reusable/Buttons/Buttons';
import backButton from 'Assets/img/svg/buttons/back.svg';
interface RouteParams {
	id: string;
}

const Membership = () => {
	const params = useParams<RouteParams>();
	const classes = useStyles();
	const dispatch = useDispatch();
	const children = useSelector((state: RootState) => state.children.children);
	useEffect(() => {
		dispatch(getMilestoneCategories());
		dispatch(GetAllKids());
	}, []);
	// JSON.parse(localStorage.getItem('currentChildId') || '{}')
	const getChildId = params.id ;
	const child = children && children.find(child => child.id === parseInt(getChildId));

	return (
		<Fragment>
			<Background backgroundColor="#FFE6D9" height="100vh" overflow="auto" display='flex' position='sticky'>
				<section className={classes.centerDIv}>
				<div className={classes.mobileBackground}>
			<BackButton image={backButton} transparent />
			</div>
					<OverlapCard>
						<h3 className="text-center my-2 py-4"> {`Select ${(child && child.fullName)?.trim()}'s   Membership Level`} </h3>
						<ul className={classes.listItems}>
							{typesOfMembership.map(membership => (
								<li key={membership.id} className="py-3">
									<MembershipCards
										id={params.id}
										image={membership.bg}
										description={changeIdentities(membership.description,child?.fullName) }
										type={membership.type}
										total={membership.total}
										info={membership.info}
										link={membership.link}
										timeline={membership.time}
										width={'100%'}
									/>
								</li>
							))}
						</ul>
					</OverlapCard>
				</section>
			</Background>
		</Fragment>
	);
};

export default Membership;
